export const isNullOrUndefined = value => [null, undefined].includes(value)
export const isDefined = value => !isNullOrUndefined(value)
